module.exports = __webpack_public_path__ + "static/WEDDING E&M-546-9cc280238ec99b0e4e7ae9278b68150f.jpg";